import {createAsyncThunk} from "@reduxjs/toolkit";
import {handlerError} from "../../../store/handleError";
import {errorCodeAPI} from "../api";
import {setModalMessage} from "../../messages/model/slice";
import {INewErrorCode, IErrorCode} from "../../../models/iErrorCode";

export const fetchAddErrorCode = createAsyncThunk(
    "error_code/add",
    async (errorCodes: INewErrorCode[], {dispatch, rejectWithValue}) => {
        try {
            const res = await errorCodeAPI.add(errorCodes);
            return res;
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export interface IFetchErrorCodesParams {
    page: number;
    limit: number;
    search?: string;
}

export const fetchGetAllErrorCode = createAsyncThunk(
    "error_code/get_all",
    async (params: IFetchErrorCodesParams, {dispatch, rejectWithValue}) => {
        try {
            return await errorCodeAPI.getAll(params);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchUpdateErrorCode = createAsyncThunk(
    "error_code/update",
    async (errorCode: IErrorCode, {rejectWithValue, dispatch}) => {
        try {
            return await errorCodeAPI.update(errorCode);
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);

export const fetchDeleteErrorCode = createAsyncThunk(
    "error_code/delete",
    async (id: string, {rejectWithValue, dispatch, getState}) => {
        try {
            await errorCodeAPI.delete(id);
            return id;
        } catch (e) {
            const msg = handlerError(e);
            dispatch(setModalMessage(msg));
            return rejectWithValue(msg);
        }
    },
);